import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { MotivoPerdaVendaExibicaoFormComponent } from './motivo-perda-venda-exibicao-form.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        MotivoPerdaVendaExibicaoFormComponent
    ],
    exports: [
        MotivoPerdaVendaExibicaoFormComponent
    ]
})
export class MotivoPerdaVendaExibicaoFormModule { }
